import { LetterPresets } from "./LetterPresets"

export const InterviewInvitation = () => {
    return (
        <>
            <LetterPresets templateType="Interview"/>
        </>
    )
}